import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import type { AssetResponse } from '../../types/assets';
import AssetCard from './AssetCard';

interface AssetCardGridProps {
  assets: AssetResponse[];
  emptyMessage: string;
  onAssetClick: (asset: AssetResponse) => void;
}

const AssetCardGrid: React.FC<AssetCardGridProps> = ({
  assets,
  emptyMessage,
  onAssetClick,
}) => {
  if (assets.length === 0) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.775rem' }}>
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        '&:hover .asset-card:not(:hover)': {
          opacity: 0.55,
          filter: 'saturate(0.7)',
        },
      }}
    >
      {assets.map(asset => (
        <Grid item xs={12} sm={6} md={3} key={asset.id}>
          <AssetCard asset={asset} onClick={onAssetClick} />
        </Grid>
      ))}
    </Grid>
  );
};

export default AssetCardGrid;
